import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[app-narrow-sidebar-profile-menu-item]',
})
export class NarrowSidebarProfileMenuItemDirective {
  @HostBinding('class') class = 'block px-3 py-1 text-sm/6 text-gray-900 focus:bg-gray-50 focus:outline-hidden';
}
